import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";

const MoveUpMoveDownButtons = ({
  setDynamicFields,
  fieldIdx,
  lookupIndex,
  lookupLength,
}) => {
  const moveUpButtonClassName = `btn-icon1 rotate-180 arrow${lookupIndex === 0 ? "-disabled" : ""
    }`;
  const moveDownButtonClassName = `btn-icon1 arrow${lookupIndex === lookupLength - 1 ? "-disabled" : ""
    }`;

  const isMoveUpDisabled = lookupIndex === 0;
  const isMoveDownDisabled = lookupIndex === lookupLength - 1;

  const handleMoveUpClick = () => {
    const newIndex = lookupIndex - 1;
    handleSwapForCheckBoxRadioDropDown(fieldIdx, newIndex, lookupIndex);
  };

  const handleMoveDownClick = () => {
    const newIndex = lookupIndex + 1;
    handleSwapForCheckBoxRadioDropDown(fieldIdx, lookupIndex, newIndex);
  };

  const handleSwapForCheckBoxRadioDropDown = (
    fieldIndex,
    firstIdx,
    secondIdx
  ) => {
    setDynamicFields((prevFields) =>
      prevFields.map((field, idx) => {
        if (fieldIndex === idx) {
          const [first, second] = field.LookupValues.slice(
            firstIdx,
            secondIdx + 1
          );
          const returnField = (index, secondIdx, first, item) => index === secondIdx ? first : item
          const itemList = field.LookupValues.map((item, index) =>
            index === firstIdx ? second : returnField(index, secondIdx, first, item)
          );
          return { ...field, LookupValues: itemList };
        }
        return field;
      })
    );
  };

  return (
    <div>
      <Button
        className={moveUpButtonClassName}
        disabled={isMoveUpDisabled}
        onClick={handleMoveUpClick}
        type="button"
        data-testid={`botton-moveUp-${lookupIndex}`}
      />
      <Button
        className={moveDownButtonClassName}
        disabled={isMoveDownDisabled}
        onClick={handleMoveDownClick}
        type="button"
        data-testid={`button-moveDown-${lookupIndex}`}
      />
    </div>
  );
};

MoveUpMoveDownButtons.propTypes = {
  setDynamicFields: PropTypes.func.isRequired,
  fieldIdx: PropTypes.number.isRequired,
  lookupIndex: PropTypes.number.isRequired,
  lookupLength: PropTypes.number.isRequired,
};
export default MoveUpMoveDownButtons;
